import { render, staticRenderFns } from "./SearchNavItemField.vue?vue&type=template&id=1a2a0951&scoped=true"
import script from "./SearchNavItemField.vue?vue&type=script&lang=js"
export * from "./SearchNavItemField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a0951",
  null
  
)

export default component.exports